/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @author Matěj Grabovský <matej.grabovsky@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Prázdná implementace pro platformy, které podporují nativní focus.
 * @implements {FocusManager}
 */
class FocusNoop {
  /** @inheritdoc */
  start() {
    // Prázdná metoda pro splnění rozhraní.
  }

  /** @inheritdoc */
  stop() {
    // Prázdná metoda pro splnění rozhraní.
  }
}

export default FocusNoop;
